exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/goals/list/goals-list.component.css
// module id = ../../../../../src/app/goals/list/goals-list.component.css
// module chunks = main